import { createDelta } from '../../../../domain/value-object/ItemDeltaInputVO'
import {
  TenantDetailDto,
  TenantUpdateDeltaInput,
} from '../../../../infrastructure/api/tenants'

// 項目と並びは uiMeta の property_layout に合わせている。
export type TenantFormModel = {
  uuid: string
  alias: string
  iconUrl: string
  displayName: string
  officialName: string
  emailDomainWhitelist: string
  skipEmailVerification: boolean
  defaultTimezoneId: string | undefined
  dailyWorkHours: number | undefined
  monthlyWorkDays: number | undefined
  financialYearEndMonth: string | undefined
  restrictTaskActualWorkByProjectPeriod: boolean
}

export const fromDetail = (detail: TenantDetailDto): TenantFormModel => ({
  uuid: detail.uuid,
  alias: detail.alias,
  iconUrl: detail.iconUrl || '',
  displayName: detail.displayName,
  officialName: detail.officialName || '',
  emailDomainWhitelist: detail.emailDomainWhitelist || '',
  skipEmailVerification: detail.skipEmailVerification,
  defaultTimezoneId: detail.defaultTimezoneId,
  dailyWorkHours: detail.dailyWorkHours,
  monthlyWorkDays: detail.monthlyWorkDays,
  financialYearEndMonth: detail.financialYearEndMonth,
  restrictTaskActualWorkByProjectPeriod:
    detail.restrictTaskActualWorkByProjectPeriod,
})

// 実際に変更された項目だけを含む差分更新ペイロードを組み立てる。
// "alias" は表示専用のため含めない。
export const toDeltaInput = (
  detail: TenantDetailDto,
  formModel: TenantFormModel
): TenantUpdateDeltaInput => {
  const before = fromDetail(detail)
  return {
    uuid: formModel.uuid,
    iconUrl: createDelta(before.iconUrl, formModel.iconUrl),
    displayName: createDelta(before.displayName, formModel.displayName),
    officialName: createDelta(before.officialName, formModel.officialName),
    emailDomainWhitelist: createDelta(
      before.emailDomainWhitelist,
      formModel.emailDomainWhitelist
    ),
    skipEmailVerification: createDelta(
      before.skipEmailVerification,
      formModel.skipEmailVerification
    ),
    defaultTimezoneId: createDelta(
      before.defaultTimezoneId,
      formModel.defaultTimezoneId
    ),
    dailyWorkHours: createDelta(
      before.dailyWorkHours,
      formModel.dailyWorkHours
    ),
    monthlyWorkDays: createDelta(
      before.monthlyWorkDays,
      formModel.monthlyWorkDays
    ),
    financialYearEndMonth: createDelta(
      before.financialYearEndMonth,
      formModel.financialYearEndMonth
    ),
    restrictTaskActualWorkByProjectPeriod: createDelta(
      before.restrictTaskActualWorkByProjectPeriod,
      formModel.restrictTaskActualWorkByProjectPeriod
    ),
  }
}
